import { useEffect, useRef } from "react";

const useRunOnce = (fn) => {
    const hasRunRef = useRef(false);
    useEffect(() => {
        if (hasRunRef.current === false) {
            hasRunRef.current = true;
            fn();
        }
    }, []);
}

export default useRunOnce;